import { AnyAction } from "redux";
import { LOGOUT_SUCCESS } from "../types/auth";
import { SET_PORTFOLIO_FILTER, SET_PORTFOLIO_HELDAWAY_STATUS, SET_PORTFOLIO_LIST, SET_SELECTED_PORTFOLIO_OBJECT, STORE_BSE_TXN_STATUS } from "../types/portfolioFilter";
import { VERIFY_OTP_PAYMENT_SUCCESS } from "../types/onBoarding";

export interface selectedPortfolioType {
    selectedPortfolio: { label: string, value: string };
    portfolioList: Array<{ label: string, value: string }>;
    isPortfolioHeldaway: boolean
    selectedPortfolioObj: Record<string, any>
    bseTxnStatus: boolean
}

const initState = {
    selectedPortfolio: {
        label: '',
        value: ''
    },
    portfolioList: [],
    isPortfolioHeldaway: false,
    selectedPortfolioObj: {},
    bseTxnStatus: false
}

export default function portfolioReducer(state = initState, action: AnyAction): Partial<selectedPortfolioType> {
    switch (action.type) {
        case VERIFY_OTP_PAYMENT_SUCCESS: {
            return {
                ...state,
                selectedPortfolio: action?.body?.portfolioId ?? ""
            }
        }
        case SET_PORTFOLIO_FILTER: {
            // console.log("action", action);
            return {
                ...state,
                selectedPortfolio: action.payload
            };
        }
        case SET_PORTFOLIO_LIST: {
            // console.log("action", action);
            return {
                ...state,
                portfolioList: action.payload
            };
        }
        case SET_PORTFOLIO_HELDAWAY_STATUS: {
            return {
                ...state,
                isPortfolioHeldaway: action.payload
            };
        }
        case SET_SELECTED_PORTFOLIO_OBJECT: {
            return {
                ...state,
                selectedPortfolioObj: action.payload
            };
        }

        case STORE_BSE_TXN_STATUS:{
            return {
                ...state,
                bseTxnStatus: action.payload
            };
        }
        case LOGOUT_SUCCESS: {
            return {
                ...initState,
            };
        }

        default:
            return state;
    }
}